import React, { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';

export default function GlobalToaster() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <Toaster
      position="top-right"
      gutter={10}
      containerStyle={{ top: 20, right: 20 }}
    />
  );
}
